import { formatDateWithOptionsBs } from "@/lib/format";

export function formatBlogDate(iso: string): string {
  return formatDateWithOptionsBs(iso, {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Europe/Sarajevo",
  });
}
